import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { Device } from '@capacitor/device';

import { FCM } from '@capacitor-community/fcm';
// utils
import { default as appHelper } from './helper.capacitor';

import http, { getBaseApiUrl } from 'utils/api/http';

import _local from 'utils/localStorageUtils';

/* const logDeviceInfo = async () => {
  const info = await Device.getInfo();
  // console.debug('info: ' + JSON.stringify(info));
  return info;
};

const logDeviceId = async () => {
  const id = await Device.getId();
  // console.debug('info id: ' + JSON.stringify(id));
  return id;
}; */

const isPushNotificationsAvailable = Capacitor.isPluginAvailable(
  'PushNotifications',
);

const registerToken = async (token) => {
  const localUser = _local.getLocalUser();
  const baseURL = getBaseApiUrl();
  //console.debug('info baseURL: ' + JSON.stringify(baseURL));
  console.debug('app run registerToken', localUser?._id)
  // Get FCM token instead the APN one returned by Capacitor
  let FCM_TOKEN = await FCM.getToken().then(r => r.token);

  if (!!appHelper?.isAndroid) {
    console.debug('is android then : switch token APN');
    FCM_TOKEN = token?.value;
  }

  // get the device id
  const uuid = await Device.getId().then(result => result.identifier);

  // Create chanel. This channel will be created by the Firebase SDK upon receiving the first push message.
  if (!!appHelper?.isAndroid) {
    PushNotifications.createChannel({
      id: 'com.polyright.schoolinked',
      name: 'Schoolinked',
      description: 'Show the notification if the app is open on your device',
      importance: 5,
      visibility: 1,
      lights: true,
      vibration: true,
    });
  }
  // update the user with the corresponding token + uuid
  if (localUser?._id) {
    try {
      const res = await http.post(
        baseURL + 'auth/token',
        {
          _id: localUser?._id,
          token: FCM_TOKEN,
          uuid: uuid,
          fcm_token: FCM_TOKEN || '',
        },
      );
      console.debug('res of auth/token', JSON.stringify(res))
    } catch (err) {
      console.debug('auth/token error', JSON.stringify(err));
    }
  }
}

const removeToken = async (userData) => {
  const localUser = userData || _local.getLocalUser();
  const baseURL = getBaseApiUrl();
  // get the device id
  const uuid = await Device.getId().then(result => result?.identifier);
  console.debug('app run removeToken', localUser?._id, uuid)

  // Delete chanel. This channel will be created by the Firebase SDK upon receiving the first push message.
  if (!!appHelper?.isAndroid) {
    PushNotifications.deleteChannel({
      id: 'com.polyright.schoolinked'
    });
  }

  // update the user with the corresponding token + uuid
  try {
    const res = await http.post(
      baseURL + 'auth/token/remove',
      {
        _id: localUser?._id,
        uuid: uuid,
      },
    );
    console.debug('res of auth/token/remove', JSON.stringify(res))
  } catch (err) {
    console.debug('auth/token/remove error', JSON.stringify(err));
  }
}

async function requestPermissionsWithRetry() {
  let maxRetries = 4;
  let retries = 0;

  while (retries <= maxRetries) {
    if (retries != maxRetries) {
      try {
        let permStatus = await PushNotifications.requestPermissions();
        if (permStatus?.receive == 'prompt' || permStatus?.receive != 'granted') {
          retries++;
        } else {
          await PushNotifications.register();
          break; // Exit the loop if permission is granted
        }
      } catch (err) {
        console.debug('PushNotifications Error (requestPermissions): ' + JSON.stringify(err));
        retries++;
      }
    } else {
      await PushNotifications.register();
      break; // Exit the loop if number of retry is end
    }
  }
}

// Get FCM token instead the APN one returned by Capacitor
const registerPush = async userId => {
  // external required step
  console.debug('app run registerPush PushNotifications');
  // register for push
  try {
    let permStatus = await PushNotifications.checkPermissions();
    if (permStatus?.receive == 'prompt' || permStatus?.receive != 'granted') {
      await requestPermissionsWithRetry();
    } else {
      await requestPermissionsWithRetry();
    }
  } catch (err) {
    console.error('info PushNotifications checkPermissions Error: ' + JSON.stringify(err))
    await requestPermissionsWithRetry();
  }

  // Enable the auto initialization of the library
  FCM.setAutoInit({ enabled: true }).then(() =>
    console.debug(`Auto init enabled`),
  );

  // Check the auto initialization status
  FCM.isAutoInitEnabled().then(r => {
    console.debug('Auto init is ' + (r.enabled ? 'enabled' : 'disabled'));
  });

  // listener on registration accept for push
  PushNotifications.addListener('registration', async token => {
    await registerToken(token);
  });

};

export default {
  isPushNotificationsAvailable,
  registerPush,
  registerToken,
  removeToken,
}
